import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

export default function NotFound() {
  const { t } = useLanguage();
  return (
    <div data-testid="not-found-page" className="flex min-h-screen flex-col items-center justify-center bg-navy px-6 text-center noise-bg">
      <p className="font-display text-7xl font-light text-gold sm:text-8xl">404</p>
      <h1 className="mt-6 font-display text-2xl font-light text-white sm:text-3xl">{t.notFound.title}</h1>
      <p className="mt-3 max-w-sm text-sm font-light text-white/50">{t.notFound.text}</p>
      <Link to="/" data-testid="not-found-home" className="btn-gold-luxe mt-10 inline-flex items-center gap-3">
        {t.notFound.cta} <ArrowRight size={14} />
      </Link>
    </div>
  );
}
